export default __webpack_public_path__ + "static/ios-e9df90f588167981b06c395185a7ea4e.png";